import { render, staticRenderFns } from "./addNewFaq.vue?vue&type=template&id=3cbc603a"
import script from "./addNewFaq.vue?vue&type=script&lang=js"
export * from "./addNewFaq.vue?vue&type=script&lang=js"
import style0 from "./addNewFaq.vue?vue&type=style&index=0&id=3cbc603a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports